<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      inline-message
      size="small"
    >
      <el-row>
        <el-form-item
          :label="$l('form_label_fbaDc') || 'FBA配送中心'"
          prop="fbaDc"
        >
          <el-input
            v-model="formData.fbaDc"
            maxlength="50"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('form_label_fbaId') || 'FBA货件编号'"
          prop="fbaId"
        >
          <el-input
            v-model="formData.fbaId"
            maxlength="20"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          :label="$l('form_label_fbaIdReferenceId') || 'FBA货件追踪编号'"
          prop="fbaIdReferenceId"
        >
          <el-input
            v-model="formData.fbaIdReferenceId"
            maxlength="20"
            show-word-limit
            clearable
          />
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: { data: { type: Array, default: () => [] } },
  data() {
    return {
      formData: {},
      rules: {
        fbaDc: [
          {
            required: true,
            message: this.$l('tips_input_fbaDc') || '请输入FBA配送中心',
            trigger: 'blur',
          },
        ],
        fbaId: [
          {
            required: true,
            message: this.$l('tips_input_fbaId') || '请输入FBA货件编号',
            trigger: 'blur',
          },
        ],
        fbaIdReferenceId: [
          {
            required: true,
            message:
              this.$l('tips_input_fbaIdReferenceId') || '请输入FBA货件追踪编号',
            trigger: 'blur',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const amzReplenishmentCode = this.data[0]?.amzReplenishmentCode || ''

      const listReplyScmKey = this.data.map((item) => {
        return `${item.amzReplenishmentDetailCode}/${item.scmCode}`
      })
      const { fbaDc = '', fbaId = '', fbaIdReferenceId = '' } = this.data.length > 1 ? {} : this.data[0] || {}
      this.formData = { amzReplenishmentCode, listReplyScmKey, fbaDc, fbaId, fbaIdReferenceId }
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomAmzReplenishmentDetailSetScmFbaApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }
      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
      this.$emit('reload')
      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
